import React, { useState } from 'react';
import { Element } from '../data/periodicTableData';
interface ElementCardProps {
  element: Element;
}
const ElementCard: React.FC<ElementCardProps> = ({
  element
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };
  return <div className="h-60 w-full perspective-1000 cursor-pointer" onClick={handleFlip} data-id="element-15">
      <div className={`relative w-full h-full transition-transform duration-500 transform-style-preserve-3d ${isFlipped ? 'rotate-y-180' : ''}`} data-id="element-16">
        {/* Front of card */}
        <div className={`absolute w-full h-full backface-hidden ${isFlipped ? 'invisible' : ''} bg-white border-2 rounded-lg shadow-md flex flex-col items-center justify-center p-4`} style={{
        borderColor: element.color
      }} data-id="element-17">
          <div className="text-xs text-gray-500 self-start" data-id="element-18">
            {element.atomicNumber}
          </div>
          <div className="text-5xl font-bold my-2" data-id="element-19">{element.symbol}</div>
          <div className="text-lg" data-id="element-20">{element.name}</div>
          <div className="text-sm mt-1" data-id="element-21">{element.atomicWeight}</div>
        </div>
        {/* Back of card */}
        <div className={`absolute w-full h-full backface-hidden ${!isFlipped ? 'invisible' : ''} bg-white border-2 rounded-lg shadow-md p-4 rotate-y-180`} style={{
        borderColor: element.color
      }} data-id="element-22">
          <h3 className="text-xl font-semibold mb-2" data-id="element-23">
            {element.name} ({element.symbol})
          </h3>
          <ul className="text-sm space-y-1" data-id="element-24">
            <li data-id="element-25">
              <span className="font-medium" data-id="element-26">Atomic Number:</span>{' '}
              {element.atomicNumber}
            </li>
            <li data-id="element-27">
              <span className="font-medium" data-id="element-28">Atomic Weight:</span>{' '}
              {element.atomicWeight}
            </li>
            <li data-id="element-29">
              <span className="font-medium" data-id="element-30">Category:</span> {element.category}
            </li>
            <li data-id="element-31">
              <span className="font-medium" data-id="element-32">State at STP:</span> {element.state}
            </li>
            <li data-id="element-33">
              <span className="font-medium" data-id="element-34">Discovered:</span>{' '}
              {element.discoveryYear}
            </li>
            {element.description && <li className="mt-2 text-xs" data-id="element-35">{element.description}</li>}
          </ul>
        </div>
      </div>
    </div>;
};
export default ElementCard;